<script setup lang="ts">

import useStore from "../store.ts";
import {watchEffect} from "vue";
import {parsePx} from "../utils/ElementUtils.js";
import {Component} from "../types.ts";

const props = defineProps<{
  item: Component
}>();

const store = useStore();

// Template selection: see docs/EXTRACTED_COMMENTS.md#c810
watchEffect(() => {
  if (props.item.children.length == 0) return;
  const element = store.components[props.item.children[0].props.id];
  const width = parsePx(element?.props.style?.width) || 0;
  const height = parsePx(element?.props.style?.height) || 0;
  if (width == 0 || height == 0) return;

  const parentWidth = parsePx(props.item?.props?.style?.width) || 0;
  const parentHeight = parsePx(props.item?.props?.style?.height) || 0;

  if (parentWidth == 0 || parentWidth == 0) return;
  if (props.item?.container_props?.scale_template && (width > parentWidth || height > parentHeight)) {
    let innerScale = Math.min(parentWidth / width, parentHeight / height);
    if (innerScale <= 0) {
      return;
    }
    element.props.style.transformOrigin = 'left top';
    element.props.style.transform = `scale(${innerScale}, ${innerScale})`;
  }
});

</script>

<template>
  <div v-bind="item.props">
    <slot></slot>
  </div>
</template>

<style>
#app {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

</style>